import { layoutInlineStyle } from '../layoutInlineStyle';
import type { LayoutNodeChildProps } from '../nodeRenderProps';
import type { StackNode } from '../types';
import { RenderNodes } from '../renderNodes';

export function Stack({
  node,
  answers,
  repeatBindings,
}: LayoutNodeChildProps<StackNode>) {
  const STACK_VARIANT_GAP: Record<'compact' | 'default' | 'loose', number> = {
    compact: 3,
    default: 4,
    loose: 6,
  };
  const gap = node.gap ?? STACK_VARIANT_GAP[node.variant ?? 'default'];
  return (
    <div
      className={[`space-y-${gap}`, node.className].filter(Boolean).join(' ')}
      style={layoutInlineStyle(node.style)}
    >
      <RenderNodes
        nodes={node.children}
        answers={answers}
        repeatBindings={repeatBindings}
      />
    </div>
  );
}
